import { render, staticRenderFns } from "./ReportUrl.vue?vue&type=template&id=0bd27b12&scoped=true&"
import script from "./ReportUrl.vue?vue&type=script&lang=js&"
export * from "./ReportUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd27b12",
  null
  
)

export default component.exports